import { getNameByProductRoute } from '../ProductBreadcrumbs/utils/create-category-breadcrumb.js';

function createProductTypeBreadcrumb(pageRoutes, path = '', transformUrl) {
    const { name , url  } = findProductTypeUrl(pageRoutes, path);
    return {
        name: name || '',
        url: url && transformUrl ? transformUrl(url) : url
    };
}
function findProductTypeUrl(pageRoutes, path) {
    // Inverse pageRoutes so we can access it by path instead of name
    const routesByPath = Object.entries(pageRoutes).reduce((acc, [key, value])=>{
        acc[value] = key;
        return acc;
    }, {});
    // Retrieve combined path segments and check if it exists in the pageRoutes
    const routes = getRouteSegmentsByPath(path);
    const productTypePath = routes.find((route)=>route in routesByPath
    );
    return productTypePath ? {
        url: productTypePath,
        name: routesByPath[productTypePath]
    } : {};
}
/**
 * Returns all possible combined path segments from a given path
 * For a path `/contact-lenses/solutions/branding` we would like to have all possible combined sections:
 *    `/contact-lenses/solutions/branding`
 *    `/contact-lenses/solutions`
 *    `/contact-lenses`
 */ function getRouteSegmentsByPath(path) {
    return path.split('/').slice(1).reduce((prev, curr, index)=>{
        // append the current path section to the previous section
        const newPathSection = prev[index].concat(`/${curr}`);
        prev.push(newPathSection);
        return prev;
    }, [
        ''
    ]).slice(1).reverse();
}
const getProductTypeName = (breadcrumb, getLabel, page)=>{
    var ref;
    const productTypeName = page && breadcrumb.url && getNameByProductRoute(breadcrumb.url, page);
    return productTypeName ? productTypeName : getLabel(`products.${(ref = breadcrumb.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()}`, {
        defaultValue: breadcrumb.name
    });
};
const capitalizeWords = (str)=>str.replace(/\b\w/g, (char)=>char.toUpperCase()
    )
;
const formatBrandSegment = (brandSegment, title, productTypeName)=>{
    const titleWithoutProductType = title.replace(new RegExp(productTypeName, 'i'), '').trim();
    const decodedSegment = decodeURIComponent(brandSegment);
    const segmentWords = decodedSegment.split('-');
    const titleLower = titleWithoutProductType.toLowerCase();
    // Find the longest matching prefix from the title
    let matchedPrefix = '';
    let remainingWords = [];
    for(let i = segmentWords.length; i > 0; i--){
        const testSegmentWithSpaces = segmentWords.slice(0, i).join(' ') // Convert hyphenated part to space format
        ;
        const testSegmentWithHyphens = segmentWords.slice(0, i).join('-') // Keep original hyphens
        ;
        if (titleLower.includes(testSegmentWithSpaces.toLowerCase())) {
            matchedPrefix = testSegmentWithSpaces // Prefer the space version
            ;
            remainingWords = segmentWords.slice(i) // Remaining words after the matched part
            ;
            break;
        }
        if (titleLower.includes(testSegmentWithHyphens.toLowerCase())) {
            matchedPrefix = testSegmentWithHyphens // Keep original hyphen format
            ;
            remainingWords = segmentWords.slice(i);
            break;
        }
    }
    // Format the output: Keep the matched prefix as found in the title
    const formattedRemaining = remainingWords.map(capitalizeWords).join(' ');
    return formattedRemaining ? `${capitalizeWords(matchedPrefix)} ${formattedRemaining}` : capitalizeWords(matchedPrefix);
};

export { capitalizeWords, createProductTypeBreadcrumb, findProductTypeUrl, formatBrandSegment, getProductTypeName, getRouteSegmentsByPath };
//# sourceMappingURL=utils.js.map
